module.exports = __webpack_public_path__ + "static/media/track.9594170b.svg";